import {
  AppointmentType,
  Establishment,
  FilterItem
} from '@/modules/accredited-establishments/api'
import { isSpecialist } from '@/modules/accredited-establishments/functions/isSpecialist'
import { ALL_ID } from '@/modules/accredited-establishments/constants/filters'

/* O handoff mostra no maximo duas tags por cartao. */
const MAX_TAGS = 2

/*
 * O backend devolve a modalidade como enum semantico (`PRESENTIAL`, `REMOTE`);
 * a redacao e do design. Por isso o rotulo e montado aqui, e nao no contrato.
 */
const getAppointmentTypeLabel = (
  appointmentTypes?: AppointmentType[]
): string | undefined => {
  if (!appointmentTypes?.length) return undefined

  const presential = appointmentTypes.includes('PRESENTIAL')
  const remote = appointmentTypes.includes('REMOTE')

  if (presential && remote) return 'Presencial e online'
  if (presential) return 'Presencial'
  if (remote) return 'Online'

  return undefined
}

/*
 * `specialities` traz todas as especialidades do prestador, em ordem que nao
 * depende da busca. Com uma especialidade filtrada, o cartao mostra ela; sem
 * filtro, a primeira da lista.
 */
const getPrimarySpecialty = (
  specialities?: string[],
  selectedSpecialty?: FilterItem
): string | undefined => {
  if (!specialities?.length) return undefined

  const selected =
    selectedSpecialty?.value === ALL_ID ? undefined : selectedSpecialty?.title

  return (
    specialities.find(speciality => speciality === selected) ?? specialities[0]
  )
}

/*
 * Unico ponto que sabe de onde vem cada tag do cartao. Hoje a API alimenta so a
 * primeira; quando HC-2692 entregar, muda aqui e nenhum componente precisa
 * saber.
 *
 * A modalidade de atendimento e tag de especialista. Hospital, laboratorio,
 * pronto-socorro e maternidade sao unidades presenciais, entao a tag nao
 * informa nada — mesmo que a API mande `appointmentTypes` para eles.
 */
const getEstablishmentTags = (
  establishment: Establishment,
  selectedSpecialty?: FilterItem
): string[] => {
  const { category, specialities, subCategory, appointmentTypes } =
    establishment

  const specialist = isSpecialist(category)

  const primary = specialist
    ? getPrimarySpecialty(specialities, selectedSpecialty)
    : subCategory

  const modality = specialist
    ? getAppointmentTypeLabel(appointmentTypes)
    : undefined

  return [primary, modality]
    .filter((tag): tag is string => Boolean(tag))
    .slice(0, MAX_TAGS)
}

export { getEstablishmentTags }
